import { Component } from 'react';
import { Card, CardBody, CardTitle, Label, Row } from 'reactstrap';
import moment from 'moment-es6';

import { formatResultTime } from '../../../services/time/time-service';
import GameIcon from '../game-icon/game-icon';
import Hr from '../hr/hr';
import InputSelect from '../input-select/input-select';

import './activity-card.css';

const gameIconStyle = {
  width: '45px',
};

class ActivityCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      result,
      game,
      difficulty,
      gameLevels,
      position,
      skill,
      settings,
      onClickRemove,
      onClickSettings,
      onChangeLevel,
      isReadOnly,
      isActive,
    } = this.props;

    const hasLevels = gameLevels.length > 1;
    const levelsDisplay = isReadOnly || !hasLevels ? 'N/A' : this.levelInput(onChangeLevel);
    const hasResults = !!result;

    const _created = hasResults && new Date(result._created);
    const createdDisplay = _created && moment(_created).format('MM/DD/YYYY h:mm a');

    return (
      <Card data-test-component="ActivityCard" className={isActive ? 'shadow-lg border-primary' : 'shadow-sm rounded'}>
        <CardTitle className="my-0 py-0">
          <Row>
            <div className="my-auto mx-3 pl-2">
              <GameIcon gameIconStyle={gameIconStyle} game={game} />
            </div>
            <div className="mr-auto text-left">
              <Label className="font-weight-bold Activity-Card-game-name">{game.name}</Label>
              <p className="mb-1 Activity-Card-game-difficulty Activity-Card-attribute">
                <span className="mr-1 font-weight-bold">Difficulty:</span>
                <span className="text-info">{difficulty.name}</span>
              </p>
            </div>

            {!isReadOnly && settings && settings.length > 0 && (
              <div className="mt-0 mr-1 ml-auto pr-1 pt-0 position-relative Activity-Card-muted-opacity">
                <i
                  data-test-element="settings"
                  className="fa fa-gear pointer Activity-Card-icon"
                  onClick={onClickSettings}
                />
              </div>
            )}

            {!isReadOnly && (
              <div className="mt-0 mr-1 pr-3 pt-0 position-relative Activity-Card-muted-opacity">
                <i
                  data-test-element="remove"
                  className="fa fa-times-circle pointer Activity-Card-icon"
                  onClick={onClickRemove}
                />
              </div>
            )}
          </Row>
        </CardTitle>
        <Hr />
        <CardBody className="py-0 ml-0 text-left">
          <div>
            <Label className="my-0 py-0 font-weight-bold small">Skill</Label>
            <p className="text-info mb-0 py-0 Activity-Card-attribute">{skill.name}</p>
          </div>
          <div>
            <Label className="my-0 py-0 font-weight-bold small">Position</Label>
            <p className="text-info mb-0 py-0 Activity-Card-attribute">{position.name}</p>
          </div>
          <div>
            <Label className="my-0 py-0 font-weight-bold small">Level</Label>
            <p className="text-info mb-0 py-0 Activity-Card-attribute">{levelsDisplay}</p>
          </div>
        </CardBody>
        {!hasResults && (
          <Row data-test-component="noResults" className="ml-auto mr-2 my-0 p-0 text-right">
            <p className="m-0 p-0 Activity-Card-game-difficulty Activity-Card-attribute">
              <span className="mr-1 font-weight-bold">Est. Duration:</span>
              <span className="text-info">{game.duration}s</span>
            </p>
          </Row>
        )}
        {hasResults && (
          <CardBody data-test-component="hasResults" className="py-0 ml-0 text-left">
            <Hr />
            <Row className="m-0 px-0 pt-2 pb-0">
              <h6 className="mp-0">
                <span className="mr-1 font-weight-bold">Activity Results</span>
              </h6>
            </Row>
            <Row className="mp-0 small">
              <p className="mp-0">
                <span className="mr-1 font-weight-bold activity_card_label">Duration:</span>
                <span className="text-info activity_card_value">{formatResultTime(result.duration)}</span>
              </p>
            </Row>
            <Row className="mp-0 small">
              <p className="mp-0">
                <span className="mr-1 font-weight-bold activity_card_label">Date:</span>
                <span className="text-info activity_card_value">{createdDisplay}</span>
              </p>
            </Row>
          </CardBody>
        )}
      </Card>
    );
  }

  levelInput = (onChangeLevel) => {
    return (
      <InputSelect
        data-test-input="levelInput"
        style={{ width: 225 }}
        name="level"
        value={this.state.level}
        onChange={onChangeLevel}
        options={this.props.gameLevels && this.levelOptions()}
        small
      />
    );
  };

  levelOptions = () => {
    const { gameLevels } = this.props;

    return gameLevels.map((level) => {
      return (
        <option key={`level_${level.id}`} className="p-0" value={level.id}>
          {level.name}
        </option>
      );
    });
  };
}

export default ActivityCard;
